module.exports = __webpack_public_path__ + "img/xiaoxiang.07ddcf0f.png";